
export const DragTypes = {
   EVENT: "event"
}